'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimezoneRest = function () {
  function TimezoneRest($http) {
    (0, _classCallCheck3.default)(this, TimezoneRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'timezones/'
    };
  }

  (0, _createClass3.default)(TimezoneRest, [{
    key: 'getList',
    value: function getList(query) {
      var params = {};
      if (query) {
        params['q'] = query;
      }
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'getUSA',
    value: function getUSA(query) {
      var params = { usa_only: true };
      if (query) {
        params['q'] = query;
      }
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }]);
  return TimezoneRest;
}();

exports.default = TimezoneRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/TimezonesResource.js
// module id = 342
// module chunks = 0